
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UPDATE_POSTING_ACTIVE_STATUS from "@/apollo/jobboard/UpdatePostingActiveStatus.gql";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      UiButton,
    }
  })
  export default class PostingActivenessToggleButton extends Vue {
    @Prop({type: String, required: true}) readonly postingId!: string;
    @Prop({type: Boolean, required: true}) readonly active!: boolean;
    @Prop({type: String, default: undefined}) readonly variant?: string;

    processing: boolean = false;

    get buttonVariant(): string {
      return this.variant
        ?  this.variant
        : 'linkButton';
    }

    get activeButtonText(): string {
      return this.active ? 'Deactivate' : 'Activate';
    }

    get size(): string {
      return this.buttonVariant === "linkButton"
        ? "no"
        : "";
    }

    async handleToggleActiveness(): Promise<void> {
      this.processing = true;

      await this.$apollo.mutate({
        mutation: UPDATE_POSTING_ACTIVE_STATUS,
        variables: {
          id: this.postingId,
          set: {active: !this.active},
        },
      });
      this.processing = false;
    }
  }
